import PropTypes from 'prop-types';
import React from 'react';
import { useRouteMatch } from 'react-router-dom';

import IString from '~components/general/i-string';
import classnames from '~components/util/classnames';
import { useOpenState } from '~components/util/hooks';

function MobileMenu(props) {
  const { children } = props;

  const [ open, setOpen ] = useOpenState();

  const { path } = useRouteMatch();
  const current = path.replace(/^\/+|\/$/g, ''); // strip leading and trailing slashes

  const toggleMenu = (e) => {
    e.stopPropagation();
    setOpen(!open);
  };

  return (
    <div className="mobileSectionMenu" style={{ flexGrow: 10 }}>
      <div className="popupButtonAndMenuContainer">
        <button className="textMenuToggler" onClick={toggleMenu}>
          <IString stringKey={`general.menu.${current || 'select'}`} />
        </button>
        <div className={classnames({ popupMenu: true, alightLeft: true, open })}>
          <div className="navMenu popupNavMenu">
            <div className="menu textOnly">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

MobileMenu.propTypes = {
  children: PropTypes.node
};

export default MobileMenu;
